export const Line = () => {
	return <div className="my-5 w-[280px] border border-solid border-[#4D4D4D]" />
}
